<template>
  <div class="auth page2">
    <div class="tab-list">
      <el-button type="primary"
                 size="small"
                 @click="
          dialogVisible = true;
          isEditRoleName = false;
        "
                 v-if="verifyPermission('Add')">添加角色</el-button>
      <ul>
        <li v-for="(item, index) in roleList"
            :key="item.id"
            :class="{ auth_active: curRoleIndex === index }"
            @click="tabRoleItemChange(index)">
          <div>{{ item.roleName }}</div>
          <div class="operation">
            <span class="el-icon-edit"
                  @click.stop="editRole(item)"
                  v-if="verifyPermission('Update')"></span>
            <span class="el-icon-delete"
                  @click.stop="deleteRole(item.id)"
                  v-if="verifyPermission('Delete')"></span>
          </div>
        </li>
      </ul>
    </div>
    <div>
      <el-form ref="form"
               :model="form"
               label-width="120px"
               size="mini"
               class="auth-table"
               label-position="left">
        <h3>
          权限配置<span style="font-size: 12px; color: red; font-weight: normal">（查询权限为基本权限，如不勾选，则表示不能查看该功能菜单）</span>
        </h3>
        <el-form-item label="菜单"
                      class="auth-table_thead">
          <div>权限</div>
        </el-form-item>
        <el-form-item :label="item.menuName"
                      v-for="item in menuList"
                      :key="item.id">
          <template v-if="item.children && item.children.length > 0">
            <div class="sitem">
              <el-form-item :label="childItem.menuName"
                            v-for="childItem in item.children"
                            :key="childItem.id">
                <div class="flex auth-list">
                  <template v-if="childItem.children && childItem.children.length > 0">
                    <div class="sitem">
                      <el-form-item :label="threeItem.menuName"
                                    v-for="threeItem in childItem.children"
                                    :key="threeItem.id">
                        <div class="flex auth-list">
                          <div v-for="authItem in threeItem.auth"
                               :key="authItem.value"
                               class="checkbox-group">
                            <el-checkbox v-model="authItem.isCheck"
                                         @change="
                                handleChange($event, threeItem, authItem)
                              ">{{ authItem.text }}</el-checkbox>
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </template>
                  <template v-for="authItem in childItem.auth">
                    <div v-if="!authItem.children"
                         :key="authItem.value"
                         class="checkbox-group">
                      <el-checkbox v-model="authItem.isCheck"
                                   @change="handleChange($event, childItem, authItem)">{{ authItem.text }}</el-checkbox>
                    </div>
                  </template>
                </div>
              </el-form-item>
            </div>
          </template>
          <template v-else>
            <div class="flex auth-list"
                 style="padding-bottom: 15px">
              <div v-for="authItem in item.auth"
                   :key="authItem.value"
                   class="checkbox-group">
                <el-checkbox v-model="authItem.isCheck"
                             @change="handleChange($event, item, authItem)">{{ authItem.text }}</el-checkbox>
              </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item style="padding: 0; border: none; margin-top: 10px">
          <el-button icon="el-icon-folder-add"
                     type="primary"
                     @click="setRoleAuth"
                     v-if="verifyPermission('Update')">保存</el-button>
          <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteRole" v-if="verifyPermission('Delete')">删除</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :title="setDialogTitlt"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="300px"
               @close="close">
      <div class="flex role-input">
        <el-input v-model="roleForm.roleName"
                  placeholder="输入角色名"
                  size="small"></el-input>
        <el-button type="primary"
                   size="small"
                   :loading="submitLoading"
                   @click="createRole">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { verifyPermissionMinix } from "@/utils/mixin";
export default {
  mixins: [verifyPermissionMinix],
  data () {
    return {
      list: [
        {
          isCheck: true,
          text: 123,
        },
      ],
      state: true,
      submitLoading: false,
      form: {},
      curRoleIndex: 0,
      dialogVisible: false,
      roleList: [],
      roleForm: {},
      authMenu: [],
      menuList: [],
      menuAuthList: [],
      currentAuthList: [],
      isEditRoleName: false,
    };
  },
  created () {
    this.getMenuList();
  },
  computed: {
    setDialogTitlt () {
      return this.isEditRoleName ? "修改角色" : "添加角色";
    },
  },
  methods: {
    // 获取角色列表
    getRoleList () {
      this.$api.role.getRoles().then((res) => {
        // console.log("role", res);
        if (res.code === 0) {
          this.roleList = res.data;
          this.getAuthByRole();
        }
      });
    },
    getMenuChildren (pid, list) {
      const children = [];
      list.forEach((item) => {
        if (item.parentId == pid) {
          if (item.auth) {
            item.auth = JSON.parse(item.auth);
            item.auth.forEach((authItem, authItemIndex, arr2) => {
              authItem.isCheck = false;
              //this.$set(arr2[y], "isCheck", false);
            });
          }
          children.push(item);
        }
      });
      return children;
    },
    generateTreeData (flatData, parentId = null) {
      const treeData = [];
      flatData.forEach((item) => {
        if (item.parentId == parentId) {
          // console.log(111, item.parentId, parentId);
          if (item.auth) {
            item.auth = JSON.parse(item.auth);

            item.auth.forEach((authItem, authItemIndex, arr2) => {
              authItem.isCheck = false;
              //this.$set(arr2[y], "isCheck", false);
            });
          }
          const children = this.generateTreeData(flatData, item.id);
          if (children.length) {
            item.children = children;
          }
          treeData.push(item);
        }
      });
      return treeData;
    },

    // 获取菜单列表
    getMenuList () {
      let flag = ''
      let company = JSON.parse(window.localStorage.getItem('CompanyDetail'))
      if (!company.companyName) {
        flag = 'woyou-c'
      } else {
        flag = 'woyou1'
      }
      this.$api.role.getAuthMenu(flag).then((res) => {
        // console.log(res);
        if (res.code === 0) {
          this.menuList = [];
          // this.menuList = this.generateTreeData(res.data, 0);
          // console.log(this.menuList);
          // this.getRoleList();

          // return;
          this.authMenu = res.data;
          // console.log(res.data);
          this.authMenu.forEach((item, index, arr) => {
            if (item.parentId == 0) {
              if (item.children && !item.auth) {
                item.children = this.authHandle(item.children)
              }
              if (item.auth && item.children.length == 0 || !item.children) {
                item.auth = JSON.parse(item.auth);

                item.auth.forEach((authItem, authItemIndex, arr2) => {
                  authItem.isCheck = false;
                  //this.$set(arr2[y], "isCheck", false);
                });
              }
              // let children = this.getMenuChildren(item.id, res.data);
              // item.children = children;

              this.menuList.push(item);
            }
          });

          this.getRoleList();
        }
      });
    },
    authHandle (array) {
      let list = []
      array.forEach((item, index, arr) => {
        if (item.auth) {
          item.auth = JSON.parse(item.auth);

          item.auth.forEach((authItem, authItemIndex, arr2) => {
            authItem.isCheck = false;
            //this.$set(arr2[y], "isCheck", false);
          });
        }
        if (!this.$globalData.flag) {
          if (item.id == 2266 || item.id == 2267 || item.id == 2268) {
            return;
          }
        }
        list.push(item)

      });
      return list
    },
    // 获取当前角色的权限
    getAuthByRole () {
      this.$api.role
        .getAuthByRole(this.roleList[this.curRoleIndex].id)
        .then((res) => {
          if (res.code === 0) {
            let roleAuthMenuList = res.data.menuAuthList;
            roleAuthMenuList.forEach((item) => {
              if (!item.auth) return;

              item.authValue = JSON.parse(item.authValue);
            });
            this.setMenuListAuth(this.menuList, roleAuthMenuList);
          }
        });
    },

    //匹配角色的菜单权限 递归形式
    setMenuListAuth (menuList, roleAuthList) {
      menuList.forEach((v, i) => {
        if (v.auth) {
          roleAuthList.forEach((vr, ir) => {
            if (v.id == vr.menuId && vr.authValue) {
              this.setCurrentAuthItemIsChecked(
                v.auth,
                JSON.parse(vr.authValue)
              );
              this.$forceUpdate();
            }
          });
        }
        if (v.children && v.children.length > 0)
          this.setMenuListAuth(v.children, roleAuthList);
      });
      //console.log("authList",this.menuList,roleAuthMenuList)
    },

    //匹配菜单是否有权限的状态
    setCurrentAuthItemIsChecked (menuItemAuth, roleItemAuth) {
      menuItemAuth.forEach((v, i, arr) => {
        roleItemAuth.forEach((vRole) => {
          if (v.value === vRole.value) {
            v.isCheck = true;
          }
        });
      });
    },

    //强制更新选中状态
    handleChange (isCheck, item, auth) {
      let num = 0;
      // console.log(item);
      if (auth.value == "Select" && auth.isCheck == true) {
        item.auth.forEach((i) => {
          i.isCheck = true;
        });
      } else if (auth.value == "Select" && auth.isCheck == false) {
        item.auth.forEach((i) => {
          i.isCheck = false;
        });
      }
      if (auth.value != "Select" && auth.isCheck == true) {
        item.auth[0].isCheck = true;
      }
      item.auth.forEach((i) => {
        if (i.value != "Select" && i.isCheck == true) {
          num++;
        }
      });
      // if (num == 0 && item.auth.length > 1) {
      //   item.auth[0].isCheck = false;
      // }
      this.$forceUpdate();
    },

    //获取设置的权限 递归调用
    getNowAuthList (menuList, nowAuthList) {
      // console.log(menuList);
      menuList.forEach((v) => {
        // console.log(v);
        if (v.children && v.children.length > 0) {
          var data = {
            menuId: v.id,
            roleId: this.roleList[this.curRoleIndex].id,
            authValue: "null",
          };

          nowAuthList.push(data);

          this.getNowAuthList(v.children, nowAuthList);
        }
        if (!v.auth) return;
        var authItems = v.auth.filter((auth) => auth.isCheck);
        if (authItems.length <= 0) return;
        var data = {
          menuId: v.id,
          roleId: this.roleList[this.curRoleIndex].id,
          authValue: JSON.stringify(authItems),
        };
        nowAuthList.push(data);
      });
    },

    // 提交保存设置权限数据
    setRoleAuth () {
      var nowAuthList = [];
      this.getNowAuthList(this.menuList, nowAuthList);

      this.submitLoading = true;
      let sendData = {
        roleId: this.roleList[this.curRoleIndex].id,
        menuAuthList: nowAuthList,
      };
      this.$api.role.setRoleAuth(sendData).then((res) => {
        if (res.code === 0) {
          this.$message.success("保存成功");
        } else {

        }
        this.submitLoading = false;
      });
    },
    // 创建角色
    createRole () {
      if (this.roleForm.roleName === "") {
        return (this.dialogVisible = false);
      }
      this.$api.role.addRole(this.roleForm).then((res) => {
        if (res.code === 0) {
          this.$message.success("添加成功");
          this.getRoleList();
          this.tabRoleItemChange(0);
          // location.reload();
        } else {
          this.$message.error("添加失败");
        }
        this.dialogVisible = false;
      });
    },
    // 修改角色
    editRole (item) {
      this.dialogVisible = true;
      this.isEditRoleName = true;
      this.$set(this.roleForm, "roleName", item.roleName);
      this.roleForm.id = item.id;
    },
    deleteRole (id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.role.deleteRole(id).then((res) => {
            if (res.code === 0) {
              this.$message.success("操作成功");
              this.getRoleList();
              // location.reload();
            }
          });
        })
        .catch(() => { });
    },
    tabRoleItemChange (index) {
      this.curRoleIndex = index;
      this.getMenuList();
    },
    close () {
      this.roleForm = {};
    },
  },
};
</script>

<style lang="less">
.page2 {
  position: relative;
  border-radius: 6px;
  padding: 16px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.el-tabs--border-card {
  height: auto !important;
}
.checkbox-group {
  label {
    margin-right: 30px !important;
  }
}
.auth {
  display: flex;
  padding: 20px;
  padding-bottom: 40px;
  h1 {
    margin: 0 0 20px 0;
    font-weight: normal;
    font-size: 18px;
  }
  .el-form {
    margin-left: 60px;
  }
  .tab-list {
    background-color: #f5f7fa;
    height: 100%;
    overflow: auto;

    .el-button {
      width: 100%;
    }
    ul {
      margin-top: 10px;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        cursor: pointer;
        border-left: 5px solid #f5f7fa;
        border-right: 5px solid #f5f7fa;
        .operation {
          opacity: 0;
          margin-left: 12px;
          transition: all 0.3s;
          span {
            margin-left: 8px;
          }
        }
        &:hover {
          .operation {
            opacity: 1;
          }
        }
      }
      .auth_active {
        background-color: #fff;
        color: var(--theme-black);
        font-weight: bold;
        border-left: 5px solid #f5f7fa;
        border-right: 5px solid #f5f7fa;
      }
    }
  }
}
.role-input {
  .el-button {
    margin-left: 10px;
  }
}
.retract {
  position: relative;
  padding-left: 80px;
  top: -57px;
}
.auth-table {
  .auth-table_thead.el-form-item {
    border-top: 1px solid #e9e9e9;
    font-weight: 600;
    padding: 5px 0;

    margin-top: 8px;
    .el-form-item__label {
      color: #333;
    }
  }
  .el-form-item {
    margin: 0;
    padding-top: 15px;
    border-bottom: 1px solid #e9e9e9;
  }
  .border-none {
    border: none;
  }
  .sitem {
    .el-form-item:first-child {
      padding-top: 0;
    }
    .el-form-item {
      padding-bottom: 15px;
    }
    .el-form-item:last-child {
      border: none;
    }
  }
}
</style>
